import { Outlet } from "react-router-dom";
import UnauthorizedMainNavigation from "components/ui/UnauthorizedMainNavigation";

const UnauthorizedLanding = ()=>{
    return(
        <div>
            <UnauthorizedMainNavigation />
            <div className="min-h-screen ">
                <Outlet />
            </div>
        </div>
    )
}

export default UnauthorizedLanding;